import { ICommonResponse } from 'api/types';
import { AcademicYearTitle } from 'components/pdfStudent';
import { splittedDataToSortedArray } from 'containers/pdfStudent/utils/splittedDataToSortedArray';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetStudyPractice } from 'icons/widgets';
import FormatGrid from 'portfolio3/features/pdf/components/FormatGrid';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { IEntity } from 'types';
import { getAcademicYearsByPeriod, getDataLoadRequests } from 'utils';

import { PdfCommonDataEntity } from '../../../../components/pdfStudent/DataEntity';
import { studySpoPracticeSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const getPracticeByAcademicYear = (data: ICommonResponse<IEntity>, academicYears: string[]) => {
  const learningYearData: Record<string, IEntity[]> = {};

  data.content.forEach((item) => {
    const startDate = new Date(item.formData.startAt);
    const endDate = new Date(item.formData.endAt);
    const periods = startDate && endDate ? getAcademicYearsByPeriod(startDate, endDate) : [];

    periods.forEach((period) => {
      if (academicYears.includes(period)) {
        if (learningYearData[period]) {
          learningYearData[period].push(item);
        } else {
          learningYearData[period] = [item];
        }
      }
    });
  });

  return splittedDataToSortedArray(learningYearData);
};

const PdfPracticeContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const practice = useAppSelector(studySpoPracticeSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().studySpoEducation });

  const hasData = practice.content.length > 0;

  const academicYearData = getPracticeByAcademicYear(practice, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Практика" Icon={IconWidgetStudyPractice}>
      {hasData &&
        academicYearData.map(([academicYear, data]) => (
          <div key={academicYear}>
            <AcademicYearTitle academicYear={academicYear} />
            <FormatGrid>
              {data.map((entity) => (
                <PdfCommonDataEntity key={entity.id || entity.recordId} entity={entity} />
              ))}
            </FormatGrid>
          </div>
        ))}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfPracticeContainer;
